import classNames from "classnames";
import React from "react";
import { useStyles } from "./styles";

export const Separator: FC = ({ innerRef, className }) => {
	const classes = useStyles();
	return <div ref={innerRef} className={classNames(classes.separator, className)} />;
};
